import React from 'react';

const MeaningfulRelationships = () => {
  const features = [
    {
      icon: "/images/img_mingcute_ai_line.png",
      title: "AI Horoscope [Porutham]",
      description: "Keep family contact details, income, and horoscopes hidden until approved."
    },
    {
      icon: "/images/img_hugeicons_id_verified.png",
      title: "Government ID\nChecked",
      description: "No anonymous accounts. Multi-factor verification ensures safety."
    },
    {
      icon: "/images/img_carbon_dashboard.png",
      title: "Elder-Supervised Dashboards",
      description: "Shared dashboards allowing parents and candidates to curate choices together."
    },
    {
      icon: "/images/img_akar_icons_chat_approve.png",
      title: "Total Confidentiality Mode",
      description: "Keep family contact details, income, and horoscopes hidden until approved."
    }
  ];

  return (
    <section
      className="relative w-full py-16 sm:py-20 md:py-24 lg:py-28"
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-white/0 via-white/80 to-white"></div>
      <div className="relative w-full max-w-[1360px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-wide bg-gradient-to-r from-[#8a216b] to-[#f03f16] bg-clip-text text-transparent mb-3 sm:mb-4">
            Exceptional Care
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-semibold text-text-primary capitalize mb-4 sm:mb-5 md:mb-6 leading-tight">
            Made for Meaningful Relationships
          </h2>
          <p className="text-base sm:text-lg text-text-primary/70 max-w-2xl mx-auto">
            Curated specifically to accommodate standard Indian courtship norms safely.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {features?.map((feature, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 text-center ${index < features?.length - 1 ? 'border-r border-text-primary/20' : ''}`}
            >
              <div className="flex justify-center mb-6 sm:mb-8">
                <img
                  src={feature?.icon}
                  alt={feature?.title}
                  className="w-10 sm:w-12 md:w-[48px] h-auto"
                />
              </div>
              <h3 className="text-xl sm:text-2xl md:text-[24px] font-semibold text-text-primary mb-3 sm:mb-4 whitespace-pre-line">
                {feature?.title}
              </h3>
              <p className="text-sm sm:text-base text-text-primary/60 leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeaningfulRelationships;